import { Vector4, Color } from 'three';
import { positiveModulo } from './modulo.util';
const BYTE_MAX = 255;
export function hexToCssString(hex = '', opacity = 1) {
    const result = hexToRgbArray(hex, undefined);
    if (!result)
        return '';
    return `rgba(${result.map(c => Math.round(c * BYTE_MAX)).join(',')},${opacity})`;
}
export function hexToRgbArray(hex, fallback) {
    const matches = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!matches)
        return fallback;
    return matches.slice(1).map(s => parseInt(s, 16) / BYTE_MAX);
}
export function hexToRgbaArray(hex, fallback, alpha = 1) {
    const matches = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!matches)
        return [...fallback, alpha];
    const result = matches.slice(1).map(s => parseInt(s, 16) / BYTE_MAX);
    result.push(alpha);
    return result;
}
export function hexToVector4(hex, alpha = 1) {
    const matches = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!matches)
        return new Vector4(0, 0, 0, alpha);
    const result = matches.slice(1).map(s => parseInt(s, 16) / BYTE_MAX);
    result.push(alpha);
    return new Vector4(...result);
}
export function hexToBytesArray(hex, fallback) {
    const matches = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (!matches)
        return [...fallback];
    const result = matches.slice(1).map(s => parseInt(s, 16));
    return result;
}
export const bytesArrayToHex = (rgb) => rgbArrayToHex(rgb.map(c => c / BYTE_MAX));
export function rgbArrayToHex(rgbArray) {
    return `#${rgbArray
        .slice(0, 3)
        .map(c => Math.round(c * BYTE_MAX)
        .toString(16)
        .padStart(2, '0'))
        .join('')}`;
}
export function rgbToHex(color) {
    const [r, g, b] = color.slice(0, 3).map(c => Math.round(c * BYTE_MAX));
    // eslint-disable-next-line no-bitwise
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`.toUpperCase();
}
export function shadeColor(color, amount) {
    return `#${color
        .replace(/^#/, '')
        .replace(/../g, color => `0${Math.min(BYTE_MAX, Math.max(0, parseInt(color, 16) + amount)).toString(16)}`.slice(-2))}`;
}
export function rgbToBytes(color) {
    const byteColor = color.slice(0, 3).map(c => Math.round(c * BYTE_MAX));
    return color.length === 4 ? [...byteColor, color[3]] : byteColor;
}
export function normalizeColor(color) {
    const normalizedColor = color.slice(0, 3).map(c => c / BYTE_MAX);
    return color.length === 4
        ? [...normalizedColor, color[3]]
        : normalizedColor;
}
export function resolvePaletteColor(color, palette) {
    if (typeof color === 'string')
        return color;
    else if (palette === undefined)
        throw new Error('Tried to resolve a palette color with no palette');
    else
        return palette.colors[color].color;
}
export function resolvePaletteVector4(color, opacity, palette) {
    const hex = resolvePaletteColor(color, palette);
    return new Vector4(...hexToRgbaArray(hex, [1, 1, 1], opacity));
}
export function contrastingColor(color) {
    const hsl = { h: 0, s: 0, l: 0 };
    const t = new Color(color);
    t.getHSL(hsl, 'srgb');
    t.setHSL(positiveModulo(hsl.h + 0.5, 1), 1, 1.0 - hsl.l);
    return t.getHexString();
}
